import AuthService from 'services/AuthService'

export default {
    handle(to, from, next) {
        AuthService.loadSession().then(() => {
            if (
                (AuthService.getActiveMember() && AuthService.getActiveMember().isSignupFinished) ||
                AuthService.isUserPracticeOther() ||
                AuthService.isUserPracticeDemo() ||
                AuthService.isUserTemporaryPhysician()
            ) {
                return next()
            }

            next({ name: 'auth.signup' })
        })
    },
}
